import img11 from './imgProject/proj1.png'

const ProjectsData = [
    {
        img: img11,
        title: 'Enterprise ETL Pipeline Simulation',
        company: 'Comcast',
        duration: 'Apr 2026 - Present',
        type: 'Offsite • Full Time',
        about: 'Designed a multi-stage ETL pipeline simulating real-world data ingestion for marketing analytics using SSIS, Azure Data Factory, and Azure SQL Database.',
        tech: 'SSIS • Azure Data Factory • Azure SQL Database • T-SQL • SQL Server Agent',
        githublink: 'https://github.com/codemanishh',
        livelink: 'https://codemanishh.netlify.app/',
    },
    {
        img: img11,
        title: 'Report Generator based on Data',
        company: 'ACI Worldwide',
        duration: 'Aug 2025 - Present',
        type: 'Offsite • Full Time',
        about: 'Implemented end-to-end data migration and reporting solutions for airport analytics, using Azure Data Factory orchestration and SQL transformations for data accuracy.',
        tech: 'MySQL • Oracle • Azure Data Factory • SQL',
        githublink: 'https://github.com/codemanishh',
        livelink: 'https://codemanishh.netlify.app/',
    },
    {
        img: img11,
        title: 'MIS Resource Allocation Tool',
        company: 'Kantar',
        duration: 'Aug 2024 - Feb 2025',
        type: 'Offsite • Full Time',
        about: 'Developed a Governance Inputs Portal using ASP.NET Core MVC and C#, including Azure AD authentication, approval workflows, and SQL Server stored procedures.',
        tech: '.NET • C# • SQL Server • ASP.NET Core 8 • Azure AD • AG-Grid',
        githublink: 'https://github.com/codemanishh',
        livelink: 'https://codemanishh.netlify.app/',
    },
    {
        img: img11,
        title: 'Ecommerce Application',
        company: 'Ineuron Intelligence',
        duration: 'Aug 2023 - Nov 2023',
        type: 'Offsite • Full Time',
        about: 'Built a responsive e-commerce application using React, HTML, CSS, and JavaScript, focusing on UI interactivity and product browsing experience.',
        tech: 'React.js • JavaScript • HTML • CSS • UX Design',
        githublink: 'https://github.com/codemanishh',
        livelink: 'https://codemanishh.netlify.app/',
    },
    {
        img: img11,
        title: 'Real-Time Chat Application Development',
        company: 'Self Work',
        duration: 'Jul 2023 - Oct 2023',
        type: 'Offsite • Full Time',
        about: 'Developed a real-time chat application using React and Node.js with Socket.IO, providing low-latency messaging and responsive UX.',
        tech: 'React.js • Node.js • Socket.IO • HTML • CSS',
        githublink: 'https://github.com/codemanishh',
        livelink: 'https://codemanishh.netlify.app/',
    },
    {
        img: img11,
        title: 'Algorithm Visualizer',
        company: 'Self Work',
        duration: 'Jan 2023 - Feb 2023',
        type: 'Offsite • Full Time',
        about: 'Created an interactive algorithm visualizer to help users understand sorting and search algorithms through visual animation.',
        tech: 'JavaScript • DSA • UI Visualization',
        githublink: 'https://github.com/codemanishh',
        livelink: 'https://codemanishh.netlify.app/',
    },
    {
        img: img11,
        title: 'Blog Writing Website Database',
        company: 'Academic Work',
        duration: 'Oct 2022 - Feb 2023',
        type: 'Offsite • Full Time',
        about: 'Designed and implemented a MySQL database backend for a blog writing website, managing authors, posts, comments, and content workflows.',
        tech: 'MySQL • HTML • CSS • PHP • JavaScript',
        githublink: 'https://github.com/codemanishh',
        livelink: 'https://codemanishh.netlify.app/',
    },
    {
        img: img11,
        title: 'Weather Web App',
        company: 'Self Work',
        duration: 'Jun 2022 - Oct 2022',
        type: 'Offsite • Full Time',
        about: 'Built a weather web app to display real-time temperature, humidity, forecast, and sunrise/sunset details using weather APIs.',
        tech: 'JavaScript • REST API • HTML • CSS',
        githublink: 'https://github.com/codemanishh',
        livelink: 'https://codemanishh.netlify.app/',
    }
]
export default ProjectsData;